import '../update-toast.css';
import { useEffect, useState, type ReactNode } from 'react';

/** How long a notice takes to slide out (update-toast.css). */
const EXIT_MS = 200;

/**
 * Fixed, centred at the bottom. It slides in and out with CSS, and stays
 * mounted while it slides out: `children` is the notice that was showing.
 */
export function ToastFrame({
  show,
  wide,
  testId = 'update-toast',
  children,
}: {
  show: boolean;
  wide: boolean;
  testId?: string;
  children: ReactNode;
}) {
  const [mounted, setMounted] = useState(show);
  if (show && !mounted) setMounted(true);

  useEffect(() => {
    if (show || !mounted) return;
    const timer = window.setTimeout(() => setMounted(false), EXIT_MS);
    return () => window.clearTimeout(timer);
  }, [show, mounted]);

  if (!mounted) return null;
  return (
    <div
      data-testid={testId}
      data-state={show ? 'open' : 'closed'}
      className="update-toast"
      // The keyframes repeat translateX(-50%), so the notice stays centred
      // while it moves.
      style={{
        position: 'fixed',
        bottom: wide ? '24px' : 'var(--spades-spacing-md)',
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 9999,
      }}
    >
      {children}
    </div>
  );
}
